<template>
  <component :is="componentType"></component>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import GenericPage from '@/pages/GenericPage.vue';
import LegalPage from '@/pages/LegalPage.vue';
import FormPage from '@/pages/FormPage.vue';
import ReusablePage from '@/pages/ReusablePage.vue';

@Component({
  components: {
    GenericPage,
    LegalPage,
    FormPage,
    ReusablePage,
  },
})
export default class Page extends Vue {
  componentType: string | null = null;

  get linkBySlug() {
    return this.$store.getters['navigation/linkBySlug'](
      this.$route.params.slug
    );
  }

  getPageComponentType(): string | null {
    if (!this.linkBySlug?.page) {
      return 'GenericPage';
    }
    switch (this.linkBySlug.page.__typename) {
      case 'LegalPage':
        return 'LegalPage';
      case 'FormPage':
        return 'FormPage';
      case 'ReusablePage':
        return 'ReusablePage';
      default:
        return 'GenericPage';
    }
  }

  created() {
    this.componentType = this.getPageComponentType();
  }
}
</script>
